// extracted by mini-css-extract-plugin
module.exports = {"root":"_d8d553d","table":"_ade10b1","header":"_cb63927"};